module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_60.b2781fcc.mp3";